// All clinic content — hardcoded (no backend for now).

export const CLINIC = {
  name: 'Disc, Spine & Decompression',
  tagline: 'AUSTIN, TEXAS',
  phone: '(512) 815-7447',
  phoneHref: 'tel:+15128157447',
  whatsapp: '15128157447',
  whatsappUrl: 'https://wa.me/15128157447?text=Hi%2C%20I%20have%20a%20question%20for%20Dr.%20Ruiz',
  email: 'disc.spine.decompression@gmail.com',
  emailHref: 'mailto:disc.spine.decompression@gmail.com',
  bookingUrl: 'https://discspinedecompression.janeapp.com',
  reviewUrl: 'https://share.google/Zb8QJceyNYCur403e',
  reviews: { rating: '5.0', count: '63+' },
  doctor: { name: 'Dr. Ruiz', years: 30, specialty: 'Chiropractic' },
  insurance: 'We work with major plans including BCBSTX PPO and UnitedHealthcare, plus auto-injury (PIP). Coverage varies by plan — contact us for benefit verification. Some advanced services, including spinal decompression, may be self-pay.',
  addressLine1: '1011 Westlake Dr',
  addressLine2: 'Austin, TX 78746',
  region: 'Westlake · Serving All of Greater Austin',
};

export const IMAGES = {
  heroWindow: 'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1200',
  clinicInterior: 'https://images.unsplash.com/photo-1630226040750-d934f017f0e4?auto=format&fit=crop&w=1200&q=80',
  exterior: 'https://static.prod-images.emergentagent.com/jobs/23b92dba-c028-4c28-a0d0-512c79a4e7db/images/8c3ab782473f6d9cdb81cf0267562dca6402f28de8e6cab6162096dd740d2c1d.jpeg',
  drRuiz: 'https://customer-assets.emergentagent.com/job_elite-spine-preview/artifacts/nv3uy8jp_ChatGPT%20Image%206%20juil.%202026%2C%2019_08_52.png',
  drRuizPortrait: 'https://customer-assets.emergentagent.com/job_elite-spine-preview/artifacts/nv3uy8jp_ChatGPT%20Image%206%20juil.%202026%2C%2019_08_52.png',
  treatmentNeck: 'https://images.pexels.com/photos/4506217/pexels-photo-4506217.jpeg?auto=compress&cs=tinysrgb&w=1200',
  treatmentBack: 'https://images.pexels.com/photos/4506111/pexels-photo-4506111.jpeg?auto=compress&cs=tinysrgb&w=1200',
};

export const ABOUT = {
  philosophy: "Dr. Ruiz believes chiropractic care should go beyond pain management — it should correct the structural source of the problem and restore the body's ability to perform at its best. That belief has guided 30 years of practice and thousands of patient outcomes.",
  technology: 'The clinic at 1011 Westlake Dr is equipped with advanced chiropractic technology: the PiezoWave2 shockwave device and ArthroStim instrument adjuster for precise, effective care.',
};

export const STATS = [
  { number: '30+', label: 'Years', sub: 'Experience' },
  { number: '63+', label: 'Five-Star', sub: 'Reviews' },
  { number: '20', label: 'Services', sub: 'Offered' },
  { number: '6', label: 'Days A Week', sub: 'Walk-Ins Welcome' },
];

// 22 services grouped into 6 categories
export const SERVICE_CATEGORIES = [
  {
    id: 'urgent',
    name: 'Urgent & Walk-In',
    tagline: 'Same-day relief — no appointment',
    services: [
      { name: 'Urgent Walk-In Adjustment', duration: '30 min', desc: 'Same-day chiropractic adjustment for acute pain — no appointment needed.', benefits: ['Seen the same day you arrive', 'Immediate assessment by Dr. Ruiz', 'Treatment begins on first visit'] },
      { name: 'Same-Day Acute Pain Relief', duration: '30 min', desc: 'Rapid relief for sudden back, neck and joint pain.', benefits: ['Targeted pain reduction', 'No referral required', 'Happy-hour pricing Mon–Fri 4–6pm'] },
      { name: 'Auto Accident Injury Care', duration: '45 min', desc: 'Same-day evaluation and treatment for whiplash and collision injuries.', benefits: ['Documentation for claims', 'Whiplash & soft-tissue care', 'Coordinated recovery plan'] },
      { name: 'Work Injury Care', duration: '45 min', desc: 'Immediate care for on-the-job injuries with full documentation.', benefits: ['Seen immediately', 'Injury documentation', 'Return-to-work guidance'] },
    ],
  },
  {
    id: 'spine',
    name: 'Spine & Disc',
    tagline: 'Correcting the structural source',
    services: [
      { name: 'Structural Spinal Remodeling (CBP)', duration: '45 min', desc: 'Corrective care to restore healthy spinal curvature and posture.', benefits: ['Corrects postural distortion', 'Long-term structural change', 'Reduces recurring pain'] },
      { name: 'Sciatica & Nerve Care', duration: '30 min', desc: 'Focused treatment for sciatic and peripheral nerve pain.', benefits: ['Relieves radiating leg pain', 'Reduces nerve compression', 'Restores mobility'] },
      { name: 'Disc Herniation Treatment', duration: '45 min', desc: 'Conservative, non-surgical care for herniated and bulging discs.', benefits: ['Non-surgical care option', 'Addresses the mechanical source', 'Plan reassessed by progress'] },
      { name: 'Denneroll Spinal Orthotics', duration: '20 min', desc: 'Orthotic devices that gently restore proper spinal curves over time.', benefits: ['Home + in-office use', 'Supports corrective care', 'Comfortable and effective'] },
    ],
  },
  {
    id: 'technology',
    name: 'Advanced Technology',
    tagline: 'Measurable, drug-free results',
    services: [
      { name: 'PiezoWave2 Shockwave Therapy', duration: '20 min', desc: 'Acoustic wave therapy for tendon, soft-tissue and chronic sports complaints.', benefits: ['Non-invasive treatment option', 'Targets tendon & soft-tissue complaints', 'Drug-free'] },
      { name: 'ArthroStim Instrument Adjusting', duration: '20 min', desc: 'Precise, gentle instrument adjusting — ideal for sensitive patients.', benefits: ['No forceful twisting', 'Great for all ages', 'Highly targeted'] },
    ],
  },
  {
    id: 'sports',
    name: 'Sports & Performance',
    tagline: 'Elite recovery for active Austin',
    services: [
      { name: 'Sports Injury Recovery', duration: '45 min', desc: 'Comprehensive treatment for athletic injuries and flare-ups.', benefits: ['Faster return to sport', 'Injury-specific protocols', 'Performance rehab'] },
      { name: 'Performance Optimization', duration: '45 min', desc: 'Movement and structural work to help athletes perform at their peak.', benefits: ['Improved mobility', 'Injury prevention', 'Elite recovery tools'] },
      { name: 'Neuromuscular / Kinesiology Taping', duration: '15 min', desc: 'Supportive taping to stabilize joints and reduce strain.', benefits: ['Supports healing tissue', 'Improves proprioception', 'Reduces swelling'] },
      { name: 'Prolordotic Neck Exerciser', duration: '15 min', desc: 'Guided cervical rehabilitation to restore neck curve and strength.', benefits: ['Restores cervical curve', 'Reduces neck tension', 'Simple guided routine'] },
    ],
  },
  {
    id: 'pain',
    name: 'Pain & Specialized',
    tagline: 'Targeted care for chronic pain',
    services: [
      { name: 'Headache & Migraine Relief', duration: '30 min', desc: 'Chiropractic care addressing the cervical origins of headaches.', benefits: ['Reduces frequency & severity', 'Drug-free approach', 'Targets root cause'] },
      { name: 'Neuromuscular Therapy', duration: '30 min', desc: 'Soft-tissue therapy for chronic muscular pain and tension.', benefits: ['Releases trigger points', 'Improves circulation', 'Relieves chronic tension'] },
      { name: 'Chronic Pain Management', duration: '45 min', desc: 'Multi-modal plans combining technology and manual care for lasting relief.', benefits: ['Personalized care plan', 'Combines advanced tech', 'Focus on function'] },
    ],
  },
  {
    id: 'family',
    name: 'Family & Wellness',
    tagline: 'Care for every stage of life',
    services: [
      { name: 'Webster Prenatal & Postpartum', duration: '30 min', desc: 'Webster-certified care supporting mothers at every stage.', benefits: ['Certified prenatal technique', 'Comfortable pregnancy care', 'Postpartum recovery'] },
      { name: 'Pediatric & Infant Adjustments', duration: '20 min', desc: 'Gentle, safe adjustments for children and infants.', benefits: ['Feather-light technique', 'Supports development', 'Same-day availability'] },
    ],
  },
];

export const ALL_SERVICES = SERVICE_CATEGORIES.flatMap((c) => c.services.map((s) => s.name));

// Homepage 6 featured services — each explained with a photo
export const FEATURED_SERVICES = [
  { n: '01', name: 'Urgent Walk-In Care', desc: 'Same-day chiropractic with no appointment needed. Walk in during open hours and Dr. Ruiz will assess and begin treatment the same visit.', image: 'https://images.unsplash.com/photo-1567850174724-5214915dff89?auto=format&fit=crop&w=900&q=80', to: '/walk-in' },
  { n: '02', name: 'Instrument Adjusting', desc: 'The ArthroStim delivers precise, gentle corrections without forceful twisting — ideal for sensitive patients, seniors and anyone who prefers a lighter touch.', image: IMAGES.treatmentNeck, to: '/technology' },
  { n: '03', name: 'Corrective Spinal Care', desc: 'Structural remodeling (CBP) and Denneroll orthotics restore your spine\u2019s healthy curvature over time — addressing the root cause of recurring pain, not just the symptom.', image: IMAGES.clinicInterior, to: '/services' },
  { n: '04', name: 'Shockwave Therapy', desc: 'PiezoWave2 acoustic wave therapy — a non-invasive option for stubborn tendon and soft-tissue complaints in appropriately selected patients.', image: 'https://images.pexels.com/photos/4506111/pexels-photo-4506111.jpeg?auto=compress&cs=tinysrgb&w=900', to: '/technology' },
  { n: '05', name: 'Prenatal & Postpartum', desc: 'Webster-certified, gentle care that keeps mothers comfortable through pregnancy and supports recovery afterward.', image: 'https://images.unsplash.com/photo-1651663303138-4dc283e15992?auto=format&fit=crop&w=900&q=80', to: '/services' },
  { n: '06', name: 'Sports & Performance', desc: "Elite recovery and performance care for Austin's most active community — from weekend warriors to competitive athletes.", image: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?auto=format&fit=crop&w=900&q=80', to: '/services' },
];

export const EQUIPMENT = [
  {
    name: 'PiezoWave2 Shockwave Therapy',
    description: 'The PiezoWave2 delivers focused acoustic pressure waves to soft tissue as a non-invasive option for chronic tendon and soft-tissue complaints in appropriately selected patients.',
    why: 'Chronic tendon and soft-tissue complaints can be persistent. Focused acoustic wave therapy is a non-invasive option that may help appropriately selected patients as part of a conservative plan.',
    how: 'Targeted acoustic pressure waves are applied to the affected region during a short, non-invasive session.',
    image: IMAGES.treatmentBack,
  },
  {
    name: 'ArthroStim Instrument Adjusting',
    description: 'The ArthroStim delivers rapid, controlled thrusts for precise, gentle adjustments — ideal for patients who prefer or require a lighter touch.',
    why: 'Not every spine responds well to manual adjusting. The ArthroStim offers precision without forceful rotation, making care accessible to every patient.',
    how: 'The instrument delivers a fast series of low-force impulses to a specific segment, restoring motion and alignment without twisting or cracking.',
    image: IMAGES.treatmentNeck,
  },
  {
    name: 'Denneroll Spinal Orthotics',
    description: 'Denneroll orthotic devices apply gentle, sustained positioning to restore healthy curvature to the neck and lower back over time — a cornerstone of corrective, structural care.',
    why: 'Loss of the natural spinal curve is associated with chronic pain and degeneration. Denneroll orthotics are designed to gradually and comfortably support restoration of that curve for appropriately selected patients.',
    how: 'The patient lies on a precisely shaped orthotic for short daily sessions, allowing the spine to remodel toward its healthy, load-bearing shape.',
    image: IMAGES.clinicInterior,
  },
  {
    name: 'Neuromuscular / Kinesiology Taping',
    description: 'Therapeutic taping supports injured joints and muscles, improves proprioception and reduces swelling while allowing full range of motion.',
    why: 'Healing tissue needs support without immobilization. Kinesiology taping stabilizes without restricting the movement that recovery requires.',
    how: 'Elastic therapeutic tape is applied along muscle and joint lines to lift the skin, improve circulation and cue proper movement patterns.',
    image: IMAGES.treatmentNeck,
  },
  {
    name: 'Prolordotic Neck Exerciser',
    description: 'A guided rehabilitation device that restores the natural cervical curve, strengthens supporting muscles and relieves chronic neck tension.',
    why: 'Forward-head posture and lost cervical curve are epidemic causes of neck pain and headaches. Targeted rehab rebuilds the structure.',
    how: 'The Prolordotic device provides controlled resistance through a simple guided routine, retraining the neck toward its healthy lordotic curve.',
    image: IMAGES.treatmentBack,
  },
];

export const PROGRAMS = [
  {
    n: '01',
    name: 'Acute Relief Program',
    tagline: 'Fast, focused pain resolution',
    description: 'A short, intensive plan designed to resolve acute pain quickly — combining hands-on adjusting with our advanced technology for rapid, measurable relief.',
    includes: ['Same-day start', 'Chiropractic adjusting', 'Instrument adjusting', 'Progress reassessment'],
  },
  {
    n: '02',
    name: 'Structural Correction Program',
    tagline: 'Long-term spinal remodeling',
    description: 'A corrective care plan focused on restoring healthy spinal alignment and curvature — addressing the root cause of recurring pain rather than the symptom.',
    includes: ['Postural assessment', 'CBP corrective care', 'Denneroll orthotics', 'Structural adjusting'],
  },
  {
    n: '03',
    name: 'Sports Performance Program',
    tagline: 'Recovery + optimization for athletes',
    description: "Built for Austin's active community — a plan that speeds recovery from injury while optimizing movement, mobility and resilience for peak performance.",
    includes: ['Movement screening', 'Shockwave therapy', 'Sports recovery care', 'Kinesiology taping'],
  },
  {
    n: '04',
    name: 'Prenatal & Family Wellness Program',
    tagline: 'Care for every stage of life',
    description: 'Gentle, Webster-certified care for expecting mothers, postpartum recovery and the whole family — supporting comfort, function and healthy development.',
    includes: ['Webster technique', 'Gentle adjusting', 'Postpartum care', 'Pediatric visits'],
  },
];

export const CONDITIONS = [
  'Acute Back Pain', 'Arm Pain', 'Arthritis', 'Auto Accident Injury', 'Bulging Disc',
  'Carpal Tunnel', 'Chronic Neck Pain', 'Degenerative Disc Disease', 'Disc Herniation', 'Fibromyalgia',
  'Foot & Ankle Pain', 'Frozen Shoulder', 'Headaches', 'Herniated Disc', 'Hip Pain',
  'Knee Pain', 'Lower Back Pain', 'Migraines', 'Muscle Spasm', 'Neck Pain',
  'Nerve Pain', 'Numbness & Tingling', 'Pinched Nerve', 'Plantar Fasciitis', 'Postpartum Pain',
  'Pregnancy Discomfort', 'Sciatica', 'Scoliosis', 'Shoulder Pain', 'Spinal Stenosis',
  'Sports Injury', 'Tendonitis', 'Tension Headache', 'TMJ Pain', 'Whiplash', 'Work Injury',
];

export const HOURS = [
  { day: 'Tue – Sun', time: '7:00 AM–12:00 PM · 2:00–7:00 PM' },
  { day: 'Monday', time: 'Closed' },
];
